import React from 'react';
import uniqWith from 'lodash/uniqWith';
import pick from 'lodash/pick';
import isEmpty from 'lodash/isEmpty';

// Components
import FilterListItem from './FilterListItem';
import SurfaceItemStatus from '../SurfaceRowComponents/SurfaceItemStatus';

// Styles
import './StatusFilterList.scss';

type StatusFilterListItemProps = {
  uniqueStatus: {
    status: string;
    status_category: string;
  };
  selectedStatuses: Array<string>;
  updateFilters: Function;
};

const StatusFilterListItem = ({ uniqueStatus, selectedStatuses = [], updateFilters }: StatusFilterListItemProps) => {
  const isChecked = selectedStatuses.includes(uniqueStatus.status);

  const handleChange = (checked: boolean) => {
    if (updateFilters) {
      if (checked) updateFilters({ status: [...selectedStatuses, uniqueStatus.status] });
      else updateFilters({ status: selectedStatuses.filter(status => status !== uniqueStatus.status) });
    }
  };

  return (
    <FilterListItem id={uniqueStatus.status} label={uniqueStatus.status} isChecked={isChecked} onChange={handleChange}>
      <div className="StatusFilterList__item">
        <SurfaceItemStatus surfaceItem={uniqueStatus} />
      </div>
    </FilterListItem>
  );
};

type Props = {
  surfaceData;
  selectedStatuses: Array<string>;
  updateFilters: Function;
};
const StatusFilterList = ({ surfaceData, selectedStatuses = [], updateFilters }: Props) => {
  if (!surfaceData) return null;

  const uniqueStatuses = uniqWith(surfaceData, (A, B) => A.status === B.status)
    .map(item => pick(item, ['status', 'status_category']))
    .filter(item => !isEmpty(item));

  return (
    <div>
      {uniqueStatuses.map(uniqueStatus => (
        <StatusFilterListItem
          key={`filter-status-${uniqueStatus.status}`}
          uniqueStatus={uniqueStatus}
          selectedStatuses={selectedStatuses}
          updateFilters={updateFilters}
        />
      ))}
    </div>
  );
};

export default StatusFilterList;
